/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AssignmentDateContextResponse } from '../models/assignment-date-context-response';
import { AssignmentDateTimestampListItemResponse } from '../models/assignment-date-timestamp-list-item-response';
import { EmptySuccessfulResponse } from '../models/empty-successful-response';
import { UpdateRequest } from '../models/update-request';

@Injectable({
  providedIn: 'root',
})
export class CustomerAssignmentDateTimestampService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getCustomerAssignmentDateTimestampList
   */
  static readonly GetCustomerAssignmentDateTimestampListPath = '/api/web/v1/customers/{customer}/assignment-dates/{assignmentDate}/timestamps';

  /**
   * Get timestamps for an assignment date.
   *
   * **Accessible only for users with permission 'FEATURE_ADMIN_ASSIGNMENTS' or 'FEATURE_ADMIN_ASSIGNMENT_DATES'**
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCustomerAssignmentDateTimestampList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerAssignmentDateTimestampList$Response(params: {

    /**
     * Customer Id.
     */
    customer: number;

    /**
     * AssignmentDate Id.
     */
    assignmentDate: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<{
'message'?: string;
'data'?: {
'assignmentDate'?: AssignmentDateContextResponse;
'timestamps'?: Array<AssignmentDateTimestampListItemResponse>;
};
}>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerAssignmentDateTimestampService.GetCustomerAssignmentDateTimestampListPath, 'get');
    if (params) {
      rb.path('customer', params.customer, {});
      rb.path('assignmentDate', params.assignmentDate, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'message'?: string;
        'data'?: {
        'assignmentDate'?: AssignmentDateContextResponse;
        'timestamps'?: Array<AssignmentDateTimestampListItemResponse>;
        };
        }>;
      })
    );
  }

  /**
   * Get timestamps for an assignment date.
   *
   * **Accessible only for users with permission 'FEATURE_ADMIN_ASSIGNMENTS' or 'FEATURE_ADMIN_ASSIGNMENT_DATES'**
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCustomerAssignmentDateTimestampList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerAssignmentDateTimestampList(params: {

    /**
     * Customer Id.
     */
    customer: number;

    /**
     * AssignmentDate Id.
     */
    assignmentDate: number;
    context?: HttpContext
  }
): Observable<{
'message'?: string;
'data'?: {
'assignmentDate'?: AssignmentDateContextResponse;
'timestamps'?: Array<AssignmentDateTimestampListItemResponse>;
};
}> {

    return this.getCustomerAssignmentDateTimestampList$Response(params).pipe(
      map((r: StrictHttpResponse<{
'message'?: string;
'data'?: {
'assignmentDate'?: AssignmentDateContextResponse;
'timestamps'?: Array<AssignmentDateTimestampListItemResponse>;
};
}>) => r.body as {
'message'?: string;
'data'?: {
'assignmentDate'?: AssignmentDateContextResponse;
'timestamps'?: Array<AssignmentDateTimestampListItemResponse>;
};
})
    );
  }

  /**
   * Path part for operation putCustomerAssignmentDateTimestampUpdate
   */
  static readonly PutCustomerAssignmentDateTimestampUpdatePath = '/api/web/v1/customers/{customer}/assignment-dates/{assignmentDate}/timestamps';

  /**
   * Update assignment date timestamps.
   *
   * **Accessible only for users with permission 'FEATURE_ADMIN_ASSIGNMENTS' or 'FEATURE_ADMIN_ASSIGNMENT_DATES'**
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putCustomerAssignmentDateTimestampUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putCustomerAssignmentDateTimestampUpdate$Response(params: {

    /**
     * Customer Id.
     */
    customer: number;

    /**
     * AssignmentDate Id.
     */
    assignmentDate: number;
    context?: HttpContext
    body: UpdateRequest
  }
): Observable<StrictHttpResponse<EmptySuccessfulResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerAssignmentDateTimestampService.PutCustomerAssignmentDateTimestampUpdatePath, 'put');
    if (params) {
      rb.path('customer', params.customer, {});
      rb.path('assignmentDate', params.assignmentDate, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EmptySuccessfulResponse>;
      })
    );
  }

  /**
   * Update assignment date timestamps.
   *
   * **Accessible only for users with permission 'FEATURE_ADMIN_ASSIGNMENTS' or 'FEATURE_ADMIN_ASSIGNMENT_DATES'**
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `putCustomerAssignmentDateTimestampUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putCustomerAssignmentDateTimestampUpdate(params: {

    /**
     * Customer Id.
     */
    customer: number;

    /**
     * AssignmentDate Id.
     */
    assignmentDate: number;
    context?: HttpContext
    body: UpdateRequest
  }
): Observable<EmptySuccessfulResponse> {

    return this.putCustomerAssignmentDateTimestampUpdate$Response(params).pipe(
      map((r: StrictHttpResponse<EmptySuccessfulResponse>) => r.body as EmptySuccessfulResponse)
    );
  }

}
